<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de sexo</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de sexos</option>
        <option v-for="TipoSexo in TiposSexo" :key="TipoSexo.TipoSexoId" :value="TipoSexo.TipoSexoId">{{TipoSexo.Nombre}}</option>        
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        TiposSexo:[],
        idDelModelo:null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput:String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted(){     
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const params = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
        this.$store.dispatch("A_PJ_Catalogo_Establecer012TipoSexo", params);
    },
    created(){
      this.cargaCatalogoDeTipoSexos();
    },
    methods:{
      cargaCatalogoDeTipoSexos(){
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.PJ.catalogos.C012TiposSexo, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.error(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              } else {              
                this.TiposSexo = respuesta.data.TiposSexo;
              }
          })
          .catch(excepcion => 
          {
            console.error(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          });            
      },      
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const params = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogo_Establecer012TipoSexo", params);
        this.$emit("valorParaElPadre",evento);           
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/012TiposSexo.vue